import type { Ticker } from 'pixi.js';

type Tween = {
  elapsed: number;
  duration: number;
  update: (p: number) => void;
  done: () => void;
};

export const easeOutQuad = (p: number): number => 1 - (1 - p) * (1 - p);
export const easeInQuad = (p: number): number => p * p;

/** Bộ tween tối giản chạy trên ticker của Pixi (không cấp phát mỗi frame ngoài mảng tween). */
export class Tweener {
  private tweens: Tween[] = [];
  /** Hệ số tốc độ (`ui.anim.speedPct` / 100). */
  speed = 1;

  constructor(ticker: Ticker) {
    ticker.add((t) => this.step(t.deltaMS));
  }

  get active(): number {
    return this.tweens.length;
  }

  to(durationMs: number, update: (p: number) => void): Promise<void> {
    const duration = Math.max(0, durationMs / this.speed);
    if (duration === 0) {
      update(1);
      return Promise.resolve();
    }
    return new Promise((done) => {
      update(0);
      this.tweens.push({ elapsed: 0, duration, update, done });
    });
  }

  private step(dt: number): void {
    if (this.tweens.length === 0) return;
    const keep: Tween[] = [];
    for (const tw of this.tweens) {
      tw.elapsed += dt;
      const p = Math.min(1, tw.elapsed / tw.duration);
      tw.update(p);
      if (p >= 1) tw.done();
      else keep.push(tw);
    }
    this.tweens = keep;
  }
}
